import {
    SendOutlined,
    StepBackwardOutlined, StepForwardOutlined
  } from '@ant-design/icons';
  import { Button, Tooltip, Space } from 'antd';
  import React from 'react';

import './Toolbar.css';

  const MatchingToolbar = (props) => {
    return (
      <Space size={16} className="custom-button-group">

        {/*<Tooltip placement="bottom" title="Matching durchführen">*/}
        {/*  <Button disabled={!props.scanningMode} icon={<SendOutlined />} onClick={props.submit}/>*/}
        {/*</Tooltip>*/}
        <Space size={0} className="custom-button-group">
            <Tooltip placement="bottom" title="Zurück">
                <Button disabled={!props.scanningMode} style={{marginRight: 5}} icon={<StepBackwardOutlined />} onClick={props.goback}/>
            </Tooltip>
            <Tooltip placement="bottom" title="Weiter">
                <Button disabled={!props.scanningMode} style={{marginRight: 15}} icon={<StepForwardOutlined />} onClick={props.skip}/>
            </Tooltip>
        </Space>
      </Space>
    )
  }

  export default MatchingToolbar
